(function ($) {
    var form = document.getElementById("musicalMindsFeedbackForm");

    if (!form) {
        return;
    }

    var isSubmitting = false;

    var userId = form.getAttribute("data-user-id") || "guest";
    var academicYear = form.getAttribute("data-academic-year") || "";
    var COMPLETE_KEY = "mm_feedback_complete_" + userId + "_" + academicYear;

    function maybeShowFeedbackModal() {
        if (!$("#feedbackModal").length) return;
        if (localStorage.getItem(COMPLETE_KEY) === "1") return;
        $("#feedbackModal").modal("show");
    }

    $(function () {
        setTimeout(maybeShowFeedbackModal, 3000);
    });

    form.addEventListener("submit", function (e) {
        if (isSubmitting) {
            e.preventDefault();
            return;
        }

        var chosen = form.querySelector('input[name="recommend"]:checked');

        if (!chosen) {
            e.preventDefault();
            var error = document.getElementById("recommendError");
            if (error) error.style.display = "block";
            return;
        }

        var error = document.getElementById("recommendError");
        if (error) error.style.display = "none";

        e.preventDefault();
        isSubmitting = true;

        var $form = $(this);
        var $submitBtn = $form.find('button[type="submit"]').first();
        var originalText = $submitBtn.text();
        var serializedData = $form.serialize();

        $form.find("input, textarea, button").prop("disabled", true);
        $submitBtn.text("Sending...");

        $.ajax({
            url: $form.prop("action"),
            method: "POST",
            data: serializedData,
        })
            .done(function () {
                localStorage.setItem(COMPLETE_KEY, "1");
                $("#feedbackModal").modal("hide");
            })
            .always(function () {
                $form.find("input, textarea, button").prop("disabled", false);
                $submitBtn.text(originalText);
                isSubmitting = false;
            });
    });
})(jQuery);
